import React, { Component } from 'react';
import DrUserForm from './forms/DrUserForm';

import './ClientView.css';

import { FormLabeledItem } from '../../components/FormUI';
import BiopedModal from '../../components/BioPedModal'
import UserDetails from './UserDetails';
import ClinicPhysicianList from '../../components/datalists/ClinicPhysicianList';
import { PhysicianDetailCard } from './PhysicianDetails';

export default class DoctorView extends Component{
    state = {};

    setView(v){     

        this.setState({view:v});
    }

    /*componentDidMount(){
        //console.log('Calendar View did Mount!!!!!!!!!!!')
        if(this.props.onSectionHeader){
            this.props.onSectionHeader(<h2 className='client-view-section-header'>Manage Doctors</h2>)
        }
    }*/

    render(){
        let view;
        switch(this.state.view){
            case 'details':
                view = <UserDetails user={this.state.client} detailCard={PhysicianDetailCard} backCaption='Back To Search' onBack={() => this.setState({view: 'search', client:null})} onEdit={(user)=> this.setState({client:user, view:'search'})} />;
            break;
            default:
                view = <div><div className='client-search'>
                            <FormLabeledItem label='Search Existing Doctors' parentItem>
                                <ClinicPhysicianList
                                    onOptionSelect={(d) => {
                                        this.setState({client:d, view:'details'})
                                    } } 
                                />
                            </FormLabeledItem>
                            
                        </div>
                        <div className='content-section'>
                            <DrUserForm user={this.state.client} />
                        </div></div>               
            break;
        }

        if(this.props.onSectionHeader){
            this.props.onSectionHeader(<h2 className='client-view-section-header'>{this.state.view === 'details'? 'Manage Doctors - Details':'Manage Doctors'}</h2>)
        }

        return(
            <div className='client-view'>
                {view}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/Clients/DoctorView.js